import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/poster_pc.jpg")